export default {"src":"/accounts/_next/static/media/climatetradeForDevelopers.d4d7fb3b.svg","height":84,"width":150,"blurWidth":0,"blurHeight":0};